import { notification } from "antd"

import {
  type NotificationType,
  notificationOptions
} from "../../constants/notification.config.ts"

export function showResponseMessage(
  response: any,
  defaultMessage = "Successfully"
): void {
  const data = response?.data
  const details = data?.details

  const type = (details?.type || "success") as NotificationType
  const message = details?.message || defaultMessage
  const description = details?.description

  notification?.[type]({
    ...notificationOptions?.[type],
    message,
    description
  })
}
